const pages = [
  {
    path: '/services',
    content: 'Explore our IT and Non-IT services including recruitment, staffing, product engineering, and digital transformation. V Adithya Infinity Pvt Ltd offers intelligent solutions tailored for your business needs. web development, web, python, java, cloud computing,cloud, skill development, customer care, BPO, HR communication skills, training, skills.',
  },
  {
    path: '/network',
    content: 'Adithya Infinity Pvt. Ltd. connects skilled professionals to growing businesses across IT and Non-IT sectors. Powering careers through a nationwide network with IT job access, non-IT workforce, and placement solutions, connect, hiring, hiring experts, experts, areas, software, cloud roles, customer support, BPO, admin, HR and Sales jobs, tallent collaboration, smarter onbording, explore hiring guides, career resources.',
  },
  {
    path: '/who-we-serve',
    content: 'Discover how V Adithya Infinity Pvt Ltd empowers IT firms, non-IT industries, job seekers, freelancers, students, and recruiters through tailored staffing and career services.',
  },
  {
    path: '/careers',
    content: 'Explore IT and Non-IT job opportunities, internships, career guidance, and build lasting collaborations with clients at V Adithya Infinity Pvt Ltd, explore oppertunities, oppertunities.',
  },
  {
    path: '/joblist',
    content: 'Browse the latest job openings at V Adithya Private Limited. Find the perfect role and apply online today for IT jobs, non-IT jobs in Hyderabad, Bengaluru, Pune.',
  },
  {
    path: '/about',
    content: 'Venkat Vedicharla is the Managing Director of Adithya Infinity Private Limited, a Hyderabad-based service-oriented IT company focused on AI-driven technology solutions and digital transformation. our team members, our team, shireesha, bharath, sundar, vardhan, srikanth, hema,keerthana,jashwini,ganesh,phani,kalyan',
  },
  {
    path: '/contact',
    content: 'Looking to apply for IT or Non-IT jobs? Contact V Adithya Infinity Pvt Ltd for career opportunities, recruitment support, staffing solutions, and personalized job consultation services across India.',
  },
  {
    path: '/our-expertise',
    content: 'Discover innovative aerospace and defense solutions from V Adithya Infinity Pvt Ltd. We deliver precision engineering, manufacturing support, and skilled workforce across India, trusted by our partners, pertners, our partners, what we offer, accelerators, awards, awards and recognitions, recognitions, trusted by our partners, partners, our partners.',
  },
  {
    path: '/automotive-mobility',
    content: 'Empowering next-gen mobility through advanced automotive solutions. Discover V Adithya Infinity\'s role in shaping connected mobility, Zinnov Zones leader 2023.',
  },
  {
    path: '/communications',
    content: 'Enabling network transformation and empowering autonomous operations. Discover our end-to-end communications engineering services for network infrastructure.',
  },
  {
    path: '/energy',
    content: 'Building a smarter and sustainable energy ecosystem. From Finland\'s Energy Capital to the World--Accelerating Clean Tech, One Innovation at a Time.',
  },
  {
    path: '/',
    content: 'From Finland\'s Energy Capital to the World--Accelerating Clean Tech, One Innovation at a Time. Explore our expertise in creating sustainable energy solutions.',
  },
  {
    path: '/landing-page',
    content: 'At Adithya Infinity, we empower IT professionals through innovation, real-time training, and meaningful career-building. Our mission is to bridge the gap between industry demands and individual potential, ensuring long-term growth and success.',
  },
];

export const searchIndex = (query) => {
  const results = pages.filter(page => 
    page.content.toLowerCase().includes(query.toLowerCase())
  );
  return results;
};
